import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestsComponent } from './requests.component';
import { DashboardModule } from '../dashboard/dashboard.module';
import { TableModule } from "../../common/utilities/table/table.module";
import { ModalModule } from 'src/app/common/components/modal/modal.module';
import { ButtonOutlineModule } from 'src/app/common/utilities/buttons/button-outline/button-outline/button-outline.module';
import { FilterModule } from 'src/app/common/components/filter/filter.module';
import { PaginationModule } from 'src/app/common/components/pagination/pagination.module';
import { RequestTableModule } from 'src/app/common/components/request-table/request-table.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@NgModule({
    declarations: [
        RequestsComponent
    ],
    imports: [
        CommonModule,
        DashboardModule,
        TableModule,
        ModalModule,
        ButtonOutlineModule,
        FilterModule,
        PaginationModule,
        RequestTableModule,
        NgxJsonViewerModule,
    ]
})
export class RequestsModule { }
